import { services } from '../data/services';
import { CTABand, PageShell } from '../components/Chrome';

export function ServiceDetailPage({ serviceId }) {
  const service = services.find((item) => item.id === serviceId) || services[0];
  const cta = <CTABand heading={service.cta} sub="Describe the goal or the problem in plain English." />;
  return (
    <PageShell active="services" cta={cta}>
      <section className="site-wrap page-head">
        <a className="crumb" href="/services/">← All services</a>
        <h1>{service.name}</h1>
        <p className="hero-sub">{service.intro}</p>
      </section>
      <section className="site-wrap detail-grid">
        <div className="detail-col">
          <h2>Sound familiar?</h2>
          <ul>{service.symptoms.map((item) => <li key={item}><span className="li-glyph" aria-hidden="true">▸</span><span>{item}</span></li>)}</ul>
        </div>
        <div className="detail-col">
          <h2>What we would do</h2>
          <ul>{service.actions.map((item) => <li key={item}><span className="li-glyph" aria-hidden="true">✓</span><span>{item}</span></li>)}</ul>
        </div>
      </section>
      <div className="site-wrap mini-steps">
        <span>How it goes:</span>
        <span className="step-chip step-chip--1">problem</span><span aria-hidden="true">→</span>
        <span className="step-chip step-chip--2">understand</span><span aria-hidden="true">→</span>
        <span className="step-chip step-chip--3">solved</span>
      </div>
    </PageShell>
  );
}
